import { useContext, useEffect, useState } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { GoodsParamsContext } from '../../../context/GoodsParamsContext';
import { bridge, isNil } from 'shared/src/utils';

export const useLogViewRecommendedModal = (mode: 'like' | 'cart') => {
  const [isLogged, setIsLogged] = useState(false);
  const { data: goodsBasic } = useGoodsBasic();
  const sno = useGoodsSno();
  // 찜탭 C군 등 route 밖에서는 GoodsParamsContext 가 주입되고 useGoodsBasic 이
  // 비활성화되므로, screen/sno 를 주입값으로 채운다. PDP 는 injected 가 없어 기존 동작.
  const injected = useContext(GoodsParamsContext);
  useEffect(() => {
    if (isLogged) return;
    if (isNil(injected) && isNil(goodsBasic)) return;

    const screen = injected?.logging?.screen ?? 'GOODS_DETAIL';
    const categories = goodsBasic?.display_categories?.[0] ?? null;

    if (mode === 'cart') {
      bridge.logAnalyticsEvent({
        name: 'VIEW_CART_RECOMMENDED_GOODS_MODAL',
        analytics: {
          EVENT_TYPE: 'VIEW_CART_RECOMMENDED_GOODS_MODAL',
          CATEGORY_NAME: categories?.name,
          CATEGORY_SNO: categories?.sno.toString(),
          GOODS_NAME: goodsBasic?.name,
          GOODS_SNO: (goodsBasic?.sno ?? sno).toString(),
          SCREEN: screen,
        },
      });
      setIsLogged(true);
    }

    if (mode === 'like') {
      bridge.logAnalyticsEvent({
        name: 'VIEW_LIKE_RECOMMENDED_GOODS_MODAL',
        analytics: {
          EVENT_TYPE: 'VIEW_LIKE_RECOMMENDED_GOODS_MODAL',
          CATEGORY_NAME: categories?.name,
          CATEGORY_SNO: categories?.sno.toString(),
          GOODS_NAME: goodsBasic?.name,
          GOODS_SNO: (goodsBasic?.sno ?? sno).toString(),
          SCREEN: screen,
        },
      });
      setIsLogged(true);
    }
  }, [goodsBasic, isLogged, mode, injected, sno]);
};
